// collapse bar
// control the next div
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";

const CollapseBar = (props) => {
  // on load, hide/show target di base on setting
  useEffect(() => {
    let thisDiv = document.getElementById(props.targetDivID);

    if (props.initStateExpand !== true) {
      thisDiv.classList.add("hide_div");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // onclick handler
  // thne user click on +/-, togglet the target div and toggle icon in bar
  function toggleDiv() {
  
    if (props.targetDivID !== undefined) {
      // get current CollapseBar, need change icon
      let bt = document.getElementById(props.id);
      // get target div id, need change the class
      let div = document.getElementById(props.targetDivID);

      if (bt.classList.contains("open_div")) {
        // change icon
        bt.classList.remove("open_div");
        bt.classList.add("close_div");
        // opend div
        div.classList.remove("show_div");
        div.classList.add("hide_div");
      } else {
        // change icon
        bt.classList.remove("close_div");
        bt.classList.add("open_div");
        // close div
        div.classList.remove("hide_div");
        div.classList.add("show_div");
      }
    } else {

    }
  }

  // move to top click handler
  function moveToTop() {

    if (props.onClickMoveTop !== undefined || props.onClickMoveTop !== null) {
      // run parent function
      props.onClickMoveTop();
    } else {
      // move to top

      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  // open link, new meeting, or new patient
  function newLink() {

    if (props.onClickNewLink !== undefined || props.onClickNewLink !== null) {
      props.onClickNewLink();
    } else {
 
    }
  }

  return (
    <div className="collapseBar">
      <div className="collapseBar_title">{props.title}</div>
      <div className="collapseBar_spacer"></div>
      <a
        // use a tag with empty href, to enable tabindex
        href=""
        className={`collapseBar_link ${props.iconNewLink}`}
        style={props.showNewLink ? {} : { display: "none" }}
        onClick={(e) => {
          e.preventDefault();
          newLink();
        }}
      >
        {props.titleNewLink}
      </a>
      <a
        href=""
        className="collapseBar_position"
        style={props.showMoveTop ? {} : { display: "none" }}
        onClick={(e) => {
          e.preventDefault();
          moveToTop();
        }}
      >
        {props.titleMoveTop}
      </a>
      <a
        href=""
        className={`collapseBar_toggle ${
          props.initStateExpand ? "open_div" : "close_div"
        }         
      `}
        style={props.showCollapseBT ? {} : { display: "none" }}
        id={props.id}
        onClick={(e) => {
          e.preventDefault();
          toggleDiv();
        }}
        rel="open or collapse"
      >
        {null}
      </a>
    </div>
  );
};

export default CollapseBar;
